module.exports = __webpack_public_path__ + "img/tick_gray2.3d1033df.svg";